import { useEffect, useState } from 'react';

/**
 * Some components have conflicts with the flickering behavior
 * of Kameleoon.
 * Those components should use this hook to avoid those conflicts
 * and render once Kameleoon is loaded
 * @returns {boolean} if kameleoon loads finish
 */
export const useAntiFlickerCheck = () => {
  const [isAntiFlickerComplete, setIsAntiFlickerComplete] = useState(false);
  useEffect(() => {
    const minDiffTime = window?.kameleoonLoadingTimeout || 1000;
    const timer = setTimeout(() => {
      setIsAntiFlickerComplete(true);
    }, minDiffTime);

    return () => clearTimeout(timer);
  }, []);

  return isAntiFlickerComplete;
};
